import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    Code: 0,
    Aisle: "",
    Level: "",
    ShortDesc: "",
    Desc: "",
    Loc: "",
    Length: "",
    Width: "",
    Height: "",
    CBM: "",    
    LengthWastage: "",
    WidthWastage: "",
    HeightWastage: "",
    NoOfPallet: "",
    Type: "",
    BinSize: "",
  },

 
   
};

const Slicebin = createSlice({
  name: "Slicebin",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_bin_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_bin_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_bin_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_bin_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.Aisle = action.payload.Aisle;
      state.value.HeadObject.Level = action.payload.Level;
      state.value.HeadObject.Loc = action.payload.Loc;
      state.value.HeadObject.Type = action.payload.Type;
      state.value.HeadObject.BinSize = action.payload.BinSize;
    } ,
    Set_bin_HeadObject_CBM_Set: (state, action) => {
      state.value.HeadObject.CBM = action.payload.CBM; 
    } 
  },
});

export const {
  Set_bin_Init,
  Set_bin_HeadObject_Set, 
  Set_bin_HeadObject_Init, 
  Set_bin_HeadObject_New_Set,
  Set_bin_HeadObject_CBM_Set
} = Slicebin.actions;
export default Slicebin.reducer;
